// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1454":"1b8300c0","1901":"e1f594b6","3742":"e1f594b6"}[chunkId] + ".chunk.css";
};